import React, { Component } from 'react';
import { Layout, Icon, Avatar } from 'antd';
import { deleteCookie, getCookie } from './../../hook';

const { Header } = Layout;
class HeaderTheme extends Component {

    constructor( props ){

        super( props );

        this.state = {
            collapsed: false,
            username: '',
            user_pic: ''
        };

        this.handleLogout = this.handleLogout.bind( this );
        
    }

    componentWillMount(){
        const user = getCookie('dv_hrms_user').split(',');
        
        this.setState({
            username: user[4],
            user_pic: user[7]
        });

    }    

    handleLogout() {
        deleteCookie('dv_hrms_auth');
        deleteCookie('dv_hrms_user');
        window.location.href = '/#/login';
    }

    render() {
        return (
            <Header style={{ background: '#fff', padding: 0 }}>
                <Icon
                    className="trigger"
                    type={this.props.collapsed ? 'menu-unfold' : 'menu-fold'}
                    onClick={this.props.onToggle} />

                <span>
                    <Avatar 
                        className="custome_pic"
                        src={ this.state.user_pic } 
                        style={{ marginBottom: '5px' }} />&nbsp; { this.state.username }</span>

                <Icon 
                    onClick={ this.handleLogout }
                    type="poweroff" className="fl_right" />


            </Header>
        )
    }
}

export default HeaderTheme


// WEBPACK FOOTER //
// ./src/components/header/index.js